import React, { useEffect } from 'react';
import './Blog.css'; // Import the CSS file
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import blog5 from '../../../assets/blog5-5.webp'; // Import the image
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
function Blog5() {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Header />
            <div className="about-page">

                <div className="blog-container">
                    <div className="blog-images">
                        <img src={blog5} alt="blog 1" />
                    </div>

                    <h1>How will the CFS® help you in your job search?</h1>
                    <p>People who found a job in finance after successfully completing Certified Finance Specialist® (CFS®) applied the same determination to their job search as they did to their CFS® preparation and success. They emphasized the techniques they used: good organization, efficiency and gathering the right tools</p>
                    <p>Using your network is also essential, use your personal contacts, join IQN (International Qualifications Network), attend job fairs and spend hours on social networks.</p>


                    <p>It is also important to work on your image and your presentation, the CFS gives you all the knowledge in finance, but it is only worth it if you know how to sell yourself!</p>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                        <Button type="primary" onClick={() => navigate('/blog4')}>Previous</Button>
                        <Button type="primary" onClick={() => navigate('/blog6')}>Next</Button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Blog5;
